import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Typography } from '../Typography';

import { Box } from '../Box';

const FakeInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(2),
  whiteSpace: 'nowrap',
  overflow: 'auto',
  textOverflow: 'ellipsis',
}));

export type FakeInputProps = {
  children: ReactNode;
};

export const FakeInput = ({ children }: FakeInputProps) => {
  return (
    <FakeInputContainer>
      <Typography>{children}</Typography>
    </FakeInputContainer>
  );
};
